export default "__VITE_ASSET__681137f9__"